export default __webpack_public_path__ + "static/media/icon3.4ccda31f.svg";